import { get, post } from '../client';

export const authApi = {
  login: (email, password) => post('/auth/login', { email, password }),
  refresh: (refreshToken) => post('/auth/refresh', { refreshToken }),
  logout: (refreshToken) => post('/auth/logout', { refreshToken }),
  me: () => get('/auth/me'),
};
